import Vue from 'vue';
import { trackEvent, tracking, debugEvent, trackUserProps } from '@/services/tracking';
import { isProd, isCanary } from '@/utils/environment';

Vue.prototype.$trackEvent = isProd() || isCanary() ? trackEvent : debugEvent;
Vue.prototype.$trackUserProps = trackUserProps;
Vue.prototype.$tracking = tracking;
